import { TableKit } from "@tiptap/extension-table";
import TextAlign from "@tiptap/extension-text-align";
import { Markdown } from "@tiptap/markdown";
import { Extensions } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

export const richTextExtensions: Extensions = [
  StarterKit,
  TextAlign.configure({ types: ["heading", "paragraph"] }),
  Markdown,
  TableKit,
];
